﻿import React, { useState, useEffect } from 'react';
import { AboutInformation } from '../models/about-information';
import { User } from '../models/user';
import { Button } from 'devextreme-react/button';
import { CrudFunctions } from '../utilities/crud-functions';

export interface Props {
    userInfo?: User;
    onOkClick?: () => void;
}

export default function AboutDma(props: Props) {
    const [information, setInformation] =
        useState<AboutInformation>();

    useEffect(() => {
        getDmaInformation();
    }, []);

    const roles = props.userInfo && props.userInfo.roles ?
        props.userInfo.roles.map(r => r.groupName).join(',') : 'NA';

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-about-title">{information ?
                        information.applicationName : ''}</div>
                </div>
            </div>

            <div className="pw-flex-wrapped-row-section">
                <div>
                    <div className="pw-comp-row">
                        <div className="pw-form-unit">
                            <div className="pw-readonly-label">{information ?
                                information.copyright : ''}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit">
                            <div className="pw-readonly-label">Version {information ?
                                information.version : ''}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit">
                            <div className="pw-readonly-label">Logged in as {props.userInfo &&
                                props.userInfo.userName ?
                                props.userInfo.userName : ''}</div>
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit">
                            <div className="pw-readonly-label">Roles: {roles}</div>
                        </div>
                    </div>
                </div>
                <div className="pw-margin-left-05">
                    <div id="deer"></div>
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button
                        text="OK" type="success"
                        height={'2.6em'}
                        onClick={onOkClick} />

                </div>
            </div>
        </div>
    );

    function onOkClick() {
        if (props.onOkClick)
            props.onOkClick();
    }

    async function getDmaInformation() {
        await CrudFunctions.getData("common/dmainformation")
            .then((data) => {
                setInformation(data);
            });
    }
}
